import { useCallback, useState } from 'react'
import Cookies from 'js-cookie'
import { set } from 'idb-keyval'
import { useUserProfile } from '../use-user-profile/useUserProfile'
import useService from '../../../service/hooks/use-service'
import { deleteLocalSession, transformCvUser, useAuthContext } from '../../auth.utils'
import { userSessionCookie } from '../../auth.constants'

const useAuthentication = () => {
    const [customMessage, setCustomMessage] = useState('')
    const [userId, setUserId] = useState('')
    const { setUserProfile } = useUserProfile()
    const { isAuthenticated, user, isLoading: isAuthLoading, logout } = useAuthContext()

    const { trigger, error, isLoading } = useService(
        useCallback(async () => {
            try {
                const profile = transformCvUser(user)
                if (!isAuthenticated || !profile) {
                    throw new Error('Error while authenticating, profile not found...')
                }

                Cookies.set(userSessionCookie, JSON.stringify(profile), {
                    expires: 14,
                })
                /**
                 * Store the auth token in indexed db
                 */
                await set('auth-token', profile.token)
                setUserId(profile.user_id)
                setUserProfile({ user: profile })
                return profile
            } catch {
                deleteLocalSession()
                setCustomMessage('Please wait while we redirect you to the login')
                logout()
            }
        }, [isAuthenticated, logout, setUserProfile, user])
    )

    return {
        trigger,
        customMessage,
        error,
        isLoading: isLoading || isAuthLoading,
        isAuthenticated,
        userId,
    }
}

export default useAuthentication
